// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3OGmg","requiredAsterisk":"Info_requiredAsterisk__4Msb5"};